import type { ProductDocument } from 'models/product';
import { useProduct } from '@util/hooks/useProduct';
import useCountdown from '@util/hooks/useCountdown';

export const ProductAuctionCountdown = ({
  product,
}: {
  product: ProductDocument;
}) => {
  const {
    data: { data },
  } = useProduct(product.id);
  const liveProduct = data ?? product;
  const startTime = liveProduct.start_time ?? 0;
  const endTime = product.end_time ?? 0;
  const isStarted = startTime < Date.now();
  const timeRemaining = useCountdown(
    startTime,
    endTime,
    isStarted ? 'end' : 'start'
  );

  return (
    <div className="absolute bottom-0 w-full p-4">
      <div
        className={`w-full rounded-[1.5rem] ${
          isStarted ? 'bg-[#1D7A1E]' : 'bg-brand-secondary'
        } p-[0.8rem] text-center text-white`}
      >
        <span
          suppressHydrationWarning
          className="block w-full text-[1.2rem] font-medium sm:text-[1.6rem]"
        >
          {isStarted ? 'Ends in ' : 'Starts in '}
          {timeRemaining.days > 0 && `${timeRemaining.days}d `}
          {timeRemaining.hours}h {timeRemaining.minutes}m{' '}
          {timeRemaining.seconds}s
        </span>
      </div>
    </div>
  );
};
